import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  card: {
    minHeight: 48,
    height: 'auto',
    width: '100%',
    paddingLeft: theme.other.spacing._12,
    paddingRight: theme.other.spacing._12,
    paddingTop: theme.other.spacing._8,
    paddingBottom: theme.other.spacing._8,
    borderRadius: theme.radius.sm,
    border: `1px solid ${theme.colors.gray[3]}`,
    textAlign: 'left',
  },
  wrapper: {
    cursor: 'pointer',
    position: 'relative',
  },
  input: {
    caretColor: 'transparent',
    cursor: 'pointer',
  },
  labelWrapper: {
    width: '100%',
  },
  error: {
    borderColor: theme.colors.red[6],
  },
  tooltip: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    cursor: 'not-allowed',
  },
  tooltipLabel: {
    color: theme.colors.gray2[9],
    paddingTop: theme.other.spacing._8,
    paddingBottom: theme.other.spacing._8,
    paddingLeft: theme.other.spacing._16,
    paddingRight: theme.other.spacing._16,
    background: theme.colors.gray2[0],
    border: `1px solid ${theme.colors.gray2[2]}`,
    borderRadius: theme.radius.sm,
  },
}));
